<template>
  <BaseControlBar :back-url="backUrl">
    <div class="flex-grow-1 section-header__title">
      {{ title || "新增公司簡介範本" }}
    </div>
    <div class="admin-group" v-if="role === 'admin'">
      <template v-if="$route.name === 'AddCompanyIntroTemplate' && !readOnly">
        <BaseButton variant="success" @click="onSubmit">提交</BaseButton>
      </template>
      <template v-else>
        <template v-if="!readOnly">
          <BaseButton variant="outline-secondary" @click="onCancel">取消</BaseButton>
          <BaseButton variant="success" @click="onSubmit">提交</BaseButton>
        </template>
        <template v-else>
          <ButtonEdit @click="onEdit">編輯</ButtonEdit>
          <ButtonRemove @click="prepareAction('REMOVE', '你已移除這個範本')">
            移除
          </ButtonRemove>
        </template>
      </template>
      <BaseActionModal
        v-model="approval"
        :isOpen="approval.modal"
        :title="'確定刪除此範本？'"
        @cancel-click="approval.modal = false"
        @hidden="approval.modal = false"
        v-stream:ok-click="onStatusUpdate$"
      ></BaseActionModal>
      <ActionSuccessModal v-model="actionSuccessModal"></ActionSuccessModal>
    </div>
  </BaseControlBar>
</template>

<script>
import { tap, switchMap } from 'rxjs/operators';
import controlBarMixin from '@/mixins/control-bar';
import BaseControlBar from '@/components/BaseControlBar.vue';
import BaseActionModal from '@/components/BaseActionModal.vue';
import ActionSuccessModal from '@/components/ActionSuccessModal.vue';
import store, { SET_LOADING } from '@/store';
import http from '../../helpers/http';
import ButtonRemove from '../button/ButtonRemove.vue';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    ButtonRemove,
    BaseActionModal,
    ActionSuccessModal,
  },
  props: {
    validate: {
      type: Function,
    },
    role: String,
    deletedBy: String,
    readOnly: {
      type: Boolean,
    },
    title: String,
  },
  data: () => ({
    approval: {
      modal: false,
      action: null,
      remarks: null,
    },
    stocksModal: false,
    isEdit: false,
    actionSuccessModal: {
      show: false,
      action: null,
      msg: null,
      back: {
        location: '/admin/company-intro-templates',
        text: '返回公司簡介範本',
      },
    },
  }),
  computed: {
    backUrl() {
      return '/admin/company-intro-templates';
    },
  },
  domStreams: ['onStatusUpdate$'],
  subscriptions() {
    return {
      statusUpdate: this.onStatusUpdate$.pipe(
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        switchMap(() => {
          const { action, msg } = this.approval;
          return http(
            {
              method: 'POST',
              url: '/agc-admin-api/companyintrotemplates/remove',
              data: {
                id: this.inputVal.id,
                deletedBy: this.deletedBy,
              },
            },
            {
              next: () => {
                if (msg) {
                  this.actionSuccessModal = {
                    ...this.actionSuccessModal,
                    show: true,
                    action,
                    msg,
                  };
                }
              },
              complete: () => {
                this.approval.modal = false;
                store.commit(SET_LOADING, false);
              },
            },
          );
        }),
      ),
    };
  },
  methods: {
    onSubmit() {
      if (this.$route.name === 'AddCompanyIntroTemplate') {
        this.$emit('submit-click');
      } else {
        this.$emit('resubmit-click');
      }
    },
    prepareAction(action, msg) {
      this.approval = {
        modal: true,
        action,
        remarks: null,
        msg,
      };
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .approval-modal {
  &__header {
    border-bottom: none;
  }
}

.admin-group {
  display: flex;
}
</style>
